import { useTranslation } from 'react-i18next'
import { mainLightGrey } from '~app/helper/Colors'

const DocumentTableLegend = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  const { t } = useTranslation()
  return (
    <div style={styles.containerStyle}>
      <div style={styles.tableHeaderStyle}>
        <div />
        <p style={{ ...styles.headerTextStyle, flex: 0.4, marginLeft: 60 }}>
          {t('documentView.sender')}
        </p>
        <p style={{ ...styles.headerTextStyle, flex: 1 }}>
          {t('returns.subject')}
        </p>
        <p style={{ ...styles.headerTextStyle, flex: 0.5 }}>
          {t('documentView.payment')}
        </p>
        <p style={{ ...styles.headerTextStyle, flex: 0.2 }}>
          {t('returns.date')}
        </p>
        <div style={{ width: 48 }} />
      </div>
      <div style={styles.tableBodyStyle}>{children}</div>
    </div>
  )
}

const styles: InlineStyles = {
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 0,
    width: '100%',
  },
  tableHeaderStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  headerTextStyle: {
    fontSize: 12,
    color: mainLightGrey,
  },
  tableBodyStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
}

export default DocumentTableLegend
